import { Notification } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _NotificationService {
  public getNotification() {
    return HttpService.get<Notification>("/notification");
  }
}

const NotificationService = new _NotificationService();

export default NotificationService;
